import { fetchWithToken } from '@utils/api';
import { API_URL } from '@data/constants';

export interface EventType {
  id: number;
  name: string;
}

export async function getEventsTypes(): Promise<EventType[]> {
  const response = await fetchWithToken(`${API_URL}/api/event-types`);

  if (!response.ok) {
    throw new Error('Error fetching event types');
  }

  const { data } = await response.json() as { data: { results: EventType[], count: number }};

  const { results } = data;

  return results;
}